import { Column, CreateDateColumn, Entity, OneToMany, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { DeheadingSample } from "./deheading-sample.entity";

@Entity("deheading_qaqc")
export class DeheadingQAQC {

    @PrimaryGeneratedColumn("increment", { name: 'deheading_qaqc_id' })
    deheadingQAQCId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'log_id'
    })
    logId: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'product_id'
    })
    varietyOfMaterial: number;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "job_no"
    })
    jobNo: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "batch_no"
    })
    batchNo: string;

    @Column("varchar", {
        nullable: false,
        length: 30,
        name: "code"
    })
    sampleCode: string;

    @Column({
        type: 'int',
        nullable: false,
        name: 'hon_qty'
    })
    hOnQty: number;

    @Column({
        type: 'int',
        nullable: false,
        name: 'hless_qty'
    })
    hLessQty: number;

    @Column('int', {
        nullable: false,
        name: "plant_id"
    })
    plantId: number;

    @CreateDateColumn({
        name: "created_at",
        type: "datetime"
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        name: "created_user",
        length: 50
    })
    createdUser: string | null;


    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        name: "updated_user",
        length: 50
    })
    updatedUser: string | null;


    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @OneToMany(type => DeheadingSample, sample => sample.sampleInfo, { cascade: true })
    deheadingSampleInfo: DeheadingSample[];
}
